var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgExpand = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 5C15.1134 5 14.8 5.3134 14.8 5.7C14.8 6.0866 15.1134 6.4 15.5 6.4L16.61 6.4L13.605 9.40503C13.3317 9.67839 13.3317 10.1216 13.605 10.395C13.8784 10.6683 14.3216 10.6683 14.595 10.395L17.6 7.38995L17.6 8.5C17.6 8.8866 17.9134 9.2 18.3 9.2C18.6866 9.2 19 8.8866 19 8.5L19 5.7C19 5.3134 18.6866 5 18.3 5H15.5ZM6.4 16.61L6.4 15.5C6.4 15.1134 6.0866 14.8 5.7 14.8C5.3134 14.8 5 15.1134 5 15.5L5 18.3C5 18.6866 5.3134 19 5.7 19H8.5C8.8866 19 9.2 18.6866 9.2 18.3C9.2 17.9134 8.8866 17.6 8.5 17.6H7.38995L10.395 14.595C10.6683 14.3216 10.6683 13.8784 10.395 13.605C10.1216 13.3317 9.67839 13.3317 9.40503 13.605L6.4 16.61Z",
    fill: "#494C5B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExpand);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/expand.fae9c239dc013eabf5ba5f70f437d442.svg";